"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInput = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const handlers_1 = require("../../utils/handlers");
require("./styles.scss");
const token_icon_1 = require("../token-icon");
const CurrencyInput = (props) => {
    const { label, error, currencySymbol = "", value = "", onChange, placeholder = "", disabled = false, warning, subLabels, decimals, } = props;
    const inputHandler = (0, handlers_1.createFormattedNumberInputHandler)(value, (pureValue) => onChange && (0, handlers_1.positiveNumericFieldHandler)(pureValue, onChange, decimals));
    const inputContainer = (0, classnames_1.default)("c-currency-input", {
        "c-currency-input--disabled": disabled,
    });
    return (react_1.default.createElement("div", { className: inputContainer },
        label && react_1.default.createElement("div", { className: "c-currency-input__label" }, label),
        react_1.default.createElement("div", { className: "c-currency-input__input-control" },
            react_1.default.createElement("div", { className: "c-currency-input__input-currency" }, currencySymbol && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(token_icon_1.TokenIcon, { symbol: currencySymbol, scale: 0.9 }),
                currencySymbol))),
            react_1.default.createElement("input", { onChange: inputHandler, disabled: disabled, placeholder: placeholder, className: "c-currency-input__input", value: (0, handlers_1.formatNumber)(value) })),
        react_1.default.createElement("div", { className: "c-currency-input__input-sub-labels" }, subLabels === null || subLabels === void 0 ? void 0 : subLabels.map((label, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index }, label)))),
        error && react_1.default.createElement("div", { className: "c-currency-input__validation" }, error),
        warning && react_1.default.createElement("div", { className: "c-currency-input__warning" }, warning)));
};
exports.CurrencyInput = CurrencyInput;
